import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteAction } from '@stores/site/action';
import type { UserAction } from '@stores/user/action';
import type { ProductAction } from '@stores/product/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import type { RouteComponentProps } from 'react-router-dom';
import { BASE_IMG_URL } from '@images/imageUrls';
import RecordContent from './components/recordContent';

interface LotteryRecordH5PageProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteAction;
    user?: UserAction;
    product?: ProductAction;
    productList?: any[];
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    navList?: Array<{ name: string; id: number; type: string }>;
    navCurrentIndex?: number;
    navClick?: (item: any, index: number) => void;
    ruleValue?: string;
}

interface LotteryRecordH5State {
    loading: boolean;
    error: any;
    pageLoaded: boolean;
    headerShowStatus: boolean;
    downloadAppStatus: boolean;
}

@inject('app', 'site', 'user', 'product')
@observer
class LotteryRecordH5Page extends BasePage<LotteryRecordH5PageProps, LotteryRecordH5State> {
    state: LotteryRecordH5State = {
        loading: false,
        error: null,
        pageLoaded: false,
        headerShowStatus: false,
        downloadAppStatus: true,
    };

    async componentDidMount() {
        const { site, location } = this.props;
        const params = new URLSearchParams(location.search);
        const isPreviewFrame = params.get('previewFrame') === '1';

        if (site) {
            this.setState(
                {
                    downloadAppStatus: site.getAppDownloadShowStatus(),
                    headerShowStatus: site.getShowHeader(),
                },
                () => {
                    site.setShowHeader(false);
                    site.setAppDownloadShowStatus(!isPreviewFrame);
                },
            );
        }

        document.title = '我的抽奖';
        super.componentDidMount();
    }

    componentWillUnmount() {
        const { site } = this.props;
        const { headerShowStatus } = this.state;

        if (site) {
            site.setShowHeader(headerShowStatus);
        }

        document.title = '';
    }

    handleBack = () => {
        this.props.history.goBack();
    };

    handleSearch = () => {
        this.props.history.push('/lotteryRecordSearch');
    };

    handleTabClick = (item: any, index: number) => {
        this.props.navClick && this.props.navClick(item, index);
    };

    handleLotteryClick = (id: string) => {
        if (!id) return;
        this.props.history.push('/lottery');
    };

    renderTabs = () => {
        const { navList = [], navCurrentIndex = 0 } = this.props;

        return (
            <div className={styles.tabRow}>
                <div className={styles.tabs}>
                    {navList.map((item, index) => {
                        const isActive = navCurrentIndex === index;

                        return (
                            <div
                                key={item.id || item.type || item.name}
                                className={styles.tabItem}
                                onClick={() => this.handleTabClick(item, index)}
                            >
                                <span className={isActive ? styles.tabTextActive : styles.tabText}>
                                    {item.name}
                                </span>
                                {isActive && <div className={styles.tabLine} />}
                            </div>
                        );
                    })}
                </div>
                <img
                    src={`${BASE_IMG_URL}/common/search.png`}
                    alt="search"
                    className={styles.searchIcon}
                    onClick={this.handleSearch}
                />
            </div>
        );
    };

    render() {
        const { site } = this.props;
        const downloadAppStatus = site?.appDownloadShowStatus ?? this.state.downloadAppStatus;

        return (
            <div className={styles.wrapper} style={{ paddingTop: downloadAppStatus ? 55 : 0 }}>
                <div className={styles.header}>
                    {this.renderTabs()}
                </div>

                <RecordContent onItemClick={this.handleLotteryClick} />
            </div>
        );
    }
}

export default withRouter(LotteryRecordH5Page);
